import toast from "react-hot-toast";
import { getCahbookUser, removeAcessToken, removeCashbookUser } from "./Storage/Storage";


export const hasError = (fieldName, ApiReducer) => {
  return ApiReducer.apiJsonError && ApiReducer.apiJsonError[fieldName];
};

export const handleLogout = (navigate) => {

  removeCashbookUser();
  removeAcessToken()
  toast.success('Logged out successfully');
  window.location.href = '/';

};


export const getCategoryDisplayName = (value) => {
  const displayNames = {
    'dashboard': "Dashboard",
    'user': 'User Management',
    "expense": "Expense Management",
    "rolesAndPermissions": "Roles And Permissions"
  };
  return displayNames[value.toLowerCase()] || value.charAt(0).toUpperCase() + value.slice(1);
};


export const hasPermission = (module, action = 'read', childType = null) => {
  const userData = getCahbookUser();
  const userPermissions = userData?.roleId?.permission;



  if (!userPermissions || !Array.isArray(userPermissions)) {
    return false;
  }

  if (childType) {
    // Check child permissions (for nested permissions like services -> parent/child)
    return checkChildPermission(userPermissions, module, childType, action);
  } else {
    // Check regular module permissions
    return checkModulePermission(userPermissions, module, action);
  }
};

const checkChildPermission = (userPermissions, parentModule, childType, action) => {
  const parentPermission = userPermissions.find(perm => perm.value === parentModule);

  if (!parentPermission || !parentPermission.child) {
    return false;
  }

  const childPermission = parentPermission.child.find(child => child.value === childType);

  if (!childPermission) {
    return false;
  }

  const permission = childPermission.permission[0];
  return permission && permission[action] === true;
};


export const checkModulePermission = (userPermissions, module, action) => {
  const modulePermission = userPermissions.find(perm => perm.value === module);

  if (!modulePermission) {
    return false;
  }

  const permission = modulePermission.permission[0];
  return permission && permission[action] === true;
};


export const getNavigationPath = (value) => {
  if (value === "expense") {
    return "/expense"
  }

  if (value === "user") {
    return "/users"
  }
  if (value === "rolesAndPermissions") {
    return "/role"
  }

  else return "/"

}

// Convert timestamp to YYYY-MM-DD format for date input
export const formatTimestampToInputDate = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Convert timestamp to readable format (DD MMM YYYY)
export const formatDate = (timestamp) => {
  if (!timestamp) return 'N/A';
  const date = new Date(timestamp);
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

/**
 * Export data to CSV format
 * @param {Array} data - Array of data objects to export
 * @param {Array} headers - Array of header objects with { title, key } format
 * @param {string} filename - Name of the file to download
 */
export const exportToCSV = (data, headers, filename = 'export.csv') => {
  try {
    // Create CSV header row
    const headerRow = headers.map(h => h.title).join(',');

    // Create CSV data rows
    const dataRows = data.map(row => {
      return headers.map(header => {
        const value = row[header.key];
        // Handle values that contain commas, quotes, or newlines
        if (value === null || value === undefined) return '';
        const stringValue = String(value);
        // Escape quotes and wrap in quotes if contains comma, quote, or newline
        if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
          return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
      }).join(',');
    });

    // Combine header and data
    const csv = [headerRow, ...dataRows].join('\n');

    // Create blob and download
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error exporting to CSV:', error);
    throw error;
  }
};

/**
 * Export data to PDF format
 * @param {Array} data - Array of data objects to export
 * @param {Array} headers - Array of header objects with { title, key } format
 * @param {string} filename - Name of the file to download
 * @param {string} title - Title to display on the PDF
 */
export const exportToPDF = async (data, headers, filename = 'export.pdf', title = 'Export Report') => {
  try {
    // Dynamically import jsPDF
    const { default: jsPDF } = await import('jspdf');

    // Import autoTable - this adds the autoTable method to jsPDF
    const { default: autoTable } = await import('jspdf-autotable');

    const doc = new jsPDF('l', 'mm', 'a4'); // Landscape orientation for more columns

    // Add title
    doc.setFontSize(16);
    doc.text(title, 14, 15);

    // Add date
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 22);

    // Prepare table data
    const tableHeaders = headers.map(h => h.title);
    const tableData = data.map(row => {
      return headers.map(header => {
        const value = row[header.key];
        return value === null || value === undefined ? '' : String(value);
      });
    });

    // Add table using autoTable
    autoTable(doc, {
      head: [tableHeaders],
      body: tableData,
      startY: 28,
      styles: {
        fontSize: 8,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [66, 139, 202],
        textColor: 255,
        fontStyle: 'bold',
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
      margin: { top: 28 },
    });

    // Save the PDF
    doc.save(filename);
  } catch (error) {
    console.error('Error exporting to PDF:', error);
    throw error;
  }
};